// extracted by css-extract-rspack-plugin
export default {"mobileVert":"PRTabPanel_mobileVert__oFaYW","root":"PRTabPanel_root__8kdCn"};